module.exports = __webpack_public_path__ + "img/iphone-2.336d3e48.jpeg";